import { Injectable } from '@angular/core';
import { Globals } from '../globals';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";
import * as JWT from 'jwt-decode';
import { Proveedor } from '../models/Proveedor';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})

export class ApiAuthService {
  private headers: HttpHeaders = new HttpHeaders({
    "Content-Type": "application/x-www-form-urlencoded"//"application/json"//,
    //Autorization: this.authService.getToken()
  });

  constructor(public globals: Globals, private httpApi: HttpClient) { }

  onLogin(usuario: string, password: string): Observable<any> {
    let httpParams = new HttpParams()
      .append("usuario", usuario)
      .append("password", password);

    return this.httpApi.post(this.globals.BASE_URL_AUTH + 'Login', httpParams, {headers: this.headers})
            .pipe(map(data => data));
  }

  setToken(token: string) {
    localStorage.setItem("userCompras", token);
  }

  getToken(): string {
    return localStorage.getItem("userCompras");
  }

  deleteToken() {
    console.log('Eliminando Token');
    localStorage.removeItem("userCompras");
  }

  getTokenDecoded(): Proveedor {
    let token = this.getToken();

    if (isNullOrUndefined(token)){
      return null;
    }

    let decoded = JWT(token); // Decodifica Payload del Token
    //console.log('Cookie'+JSON.stringify(decoded));
    let proveedor: Proveedor;

    proveedor = {
      Correo: decoded['email'],
      RFC: decoded['nameid'],
      Tipo: decoded['role'],
      TipoProv:decoded['birthdate']
    };
    return proveedor;
  }


  restableceContra(correo: string) {
    let httpParams = new HttpParams()
        .append("url", this.globals.BASE_URL_RESTABLECE)
        .append("correo", correo);
    return this.httpApi.post(this.globals.BASE_URL_AUTH + `restableceContrasena_E`, httpParams)
                .pipe(map(data => data));
  }

  reenviarCorreo(correo: string) {
    let httpParams = new HttpParams()
        .append("url", this.globals.BASE_URL_VERIFICA)
        .append("correo", correo);
    return this.httpApi.post(this.globals.BASE_URL_AUTH + `reenviarCorreo_E`, httpParams)
                .pipe(map(data => data));
  }

  verificaCorreo(correo: string) {
    let httpParams = new HttpParams()
        .append("url", this.globals.BASE_URL_VERIFICA)
        .append("correo", correo);
    return this.httpApi.post(this.globals.BASE_URL_AUTH + `verificaCorreo_E`, httpParams)
                .pipe(map(data => data));
  }

  checaToken(token: string) {
    return this.httpApi.get(this.globals.BASE_URL_AUTH + `validaToken_E?token=${ token }`)
                .pipe(map(data => data));
  }

  verificaToken(token: string) {
    return this.httpApi.get(this.globals.BASE_URL_AUTH + `verificacionCuenta_E?token=${ token }`)
                .pipe(map(data => data));
  }

  refrescaToken(token: string) {
    let httpParams = new HttpParams()
        .append("token", token);
    return this.httpApi.post(this.globals.BASE_URL_AUTH + `refrescaToken_E`, httpParams)
                .pipe(map(data => data));
  }

  activarUsuario(token: string) {
    let httpParams = new HttpParams()
        .append("token", token);

        return this.httpApi.post(this.globals.BASE_URL_AUTH + `activarUsuario_E`, httpParams)
                    .pipe(map(data => data ));
  }

  cambiarContra(correo: string, contra: string, token: string) {
    let httpParams = new HttpParams()
        .append("correo", correo)
        .append("contra", contra)
        .append("token", token);

        return this.httpApi.post(this.globals.BASE_URL_AUTH + `cambiarContra_E`, httpParams)
                    .pipe(map(data => data ));
  }



}
